import { ref } from 'vue';

export function useGeoLocation() {
  const status = ref('idle'); // idle | requesting | granted | denied | error
  const error = ref(null);

  function request({ enableHighAccuracy = true, timeout = 10_000, maximumAge = 60_000 } = {}) {
    status.value = 'requesting';
    error.value = null;

    return new Promise((resolve, reject) => {
      if (typeof navigator === 'undefined' || !navigator.geolocation) {
        status.value = 'error';
        error.value = new Error('Geolocation not available');
        reject(error.value);
        return;
      }

      navigator.geolocation.getCurrentPosition(
        (pos) => {
          status.value = 'granted';
          resolve({
            latitude: pos.coords.latitude,
            longitude: pos.coords.longitude,
            accuracy: pos.coords.accuracy,
          });
        },
        (err) => {
          status.value = err?.code === 1 ? 'denied' : 'error';
          error.value = err ?? new Error('Geolocation failed');
          reject(error.value);
        },
        { enableHighAccuracy, timeout, maximumAge }
      );
    });
  }

  return { status, error, request };
}

